import { faBan } from '@fortawesome/pro-solid-svg-icons';
import type { DialogProps } from '@reach/dialog';
import type { FC } from 'react';
import type { CancelOrganizationAssignmentRequest } from 'src/apis/monolith/use-cancel-organization-assignment';
import { Modal } from 'src/components/overlay/modal';
import { useCountdown } from 'src/hooks/use-countdown';

type Props = Pick<DialogProps, 'onDismiss'> & {
  cancelAssignment: CancelOrganizationAssignmentRequest;
  organisationName: string;
};

export const CancelOrganizationAssignmentModal: FC<Props> = ({
  onDismiss,
  cancelAssignment,
  organisationName,
}) => {
  const seconds = useCountdown();
  return (
    <Modal
      title="Cancel Organisation Assignment"
      icon={faBan}
      onDismiss={onDismiss}
      footer={{
        confirmButton: {
          label: seconds
            ? `Wait ${seconds}s to proceed...`
            : cancelAssignment.pending
              ? 'Processing...'
              : 'Cancel Assignment',
          onClick: () => cancelAssignment.execute(),
          dataTestId: seconds === 0 ? 'cancel-assignment-submit' : undefined,
          disabled: cancelAssignment.pending || seconds !== 0,
        },
      }}
    >
      <p data-testid="cancel-org-assignment-modal-description">
        Please, confirm that you want to cancel the organisation assignment and
        all user assignments to <strong>{organisationName}</strong>.
      </p>
    </Modal>
  );
};
